import * as React from "react"

import { SKU_DUPLICATES_ROUTES, USER_ROLE } from "@constants"
import AppLayout from "Layout"
import SkuDuplicatesPage from "./index"


export const SkuDuplicatesRoutes = {
    path: SKU_DUPLICATES_ROUTES.PATH,
    title: SKU_DUPLICATES_ROUTES.TITLE,
    icon: 'clone',
    iconWeight: 'light',
    element: <AppLayout />,
    description: SKU_DUPLICATES_ROUTES.SUBTITLE,
    access: USER_ROLE.ADMIN,
    children: [{
        element: <SkuDuplicatesPage />,
        index: true
    }]
}
